import { createSlice } from "@reduxjs/toolkit";

const loginConst =
  localStorage.getItem("loginData") !== null
    ? JSON.parse(localStorage.getItem("loginData"))
    : {};
const initialState = {
  loginData: loginConst,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    changeLoginData: (state, logindata) => {
      localStorage.setItem("loginData", JSON.stringify(logindata.payload));
      return { loginData: logindata.payload };
    },
    getLoginData: (state) => {
      return { loginData: state.loginData };
    },
    logOut: (state) => {
      localStorage.removeItem("loginData");
      localStorage.removeItem("mobilePageLanguage");
      localStorage.removeItem("applicationToken");
      return { loginData: {} };
    },
  },
});

export const { changeLoginData, getLoginData, logOut } = loginSlice.actions;
export default loginSlice.reducer;
